import React from 'react';

const SimpleInfoModal = ({
    isVisible,
    onClose,
    title,
    content,
    children,
    closeText = "닫기",
    maxWidth = "max-w-sm",
    isLoading = false
}) => {
    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className={`bg-white rounded-lg p-6 m-4 w-full ${maxWidth} max-h-[80vh] flex flex-col`}>
                {title && (
                    <h3 className="text-lg font-semibold mb-4 text-center text-gray-900 flex-shrink-0">{title}</h3>
                )}

                {/* 컨텐츠 영역 - 스크롤 가능 */}
                <div className="flex-1 overflow-y-auto mb-6">
                    {content && (
                        <div className="text-gray-700 leading-relaxed whitespace-pre-wrap">
                            {content}
                        </div>
                    )}
                    {children}
                </div>

                {/* 닫기 버튼 - 항상 하단에 고정 */}
                <div className="flex justify-center flex-shrink-0">
                    <button
                        onClick={onClose}
                        disabled={isLoading}
                        className="px-6 py-3 bg-gray-100 text-gray-700 rounded-lg active:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed font-medium"
                    >
                        {isLoading ? '처리 중...' : closeText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SimpleInfoModal;
